//LOGO
export const LOGO = '/assets/images/zipLogo.png'
// export const FOOTER_LOGO = '/assets/svg/footer-logo.svg'
export const FOOTER_LOGO = '/assets/images/zipLogo.png'
export const SITE_NAME = 'Zipperbuy'
export const SITE_URL = 'zipperbuy.com'

export const FALLBACK_IMAGE = (e) => {
    e.target.src = '/assets/images/noImage.png'
}
